import { useAuth0 } from "@auth0/auth0-react";
import { useCallback } from "react";

const AUTH_PARAMS = {
  audience: "https://dev-yudz81r54mtavkzj.us.auth0.com/api/v2/",
  scope: "read:current_user",
} as const;

export const RELOGIN_ERRORS = new Set<string>([
  "login_required",
  "consent_required",
  "invalid_grant",
  "interaction_required",
]);

export function useAuthenticatedFetch() {
  const { getAccessTokenSilently, loginWithRedirect } = useAuth0();

  const getToken = useCallback(async (): Promise<string> => {
    try {
      const token = await getAccessTokenSilently({ authorizationParams: AUTH_PARAMS });
      return token;
    } catch (error) {
      if (RELOGIN_ERRORS.has((error as { error?: string })?.error ?? "")) {
        loginWithRedirect({ authorizationParams: AUTH_PARAMS });
      }
      throw error;
    }
  }, [getAccessTokenSilently, loginWithRedirect]);

  const relogin = useCallback(() => {
    loginWithRedirect({ authorizationParams: AUTH_PARAMS });
  }, [loginWithRedirect]);

  return { getToken, relogin };
}